import { DeleteColumnOutlined, DeleteOutlined, SearchOutlined, UserAddOutlined } from '@ant-design/icons'
import { Form, Typography, Radio, Space, Input, Select, Button, Col, Flex } from 'antd'
import { useEffect, useState } from 'react'
const { TextArea } = Input

const questionStyles = {
    // fontFamily: 'Lato',
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '22px',
    letterSpacing: '0px',
    color: '#07224D',
    marginTop: 0
}

const formItemStyles = {
    marginBottom: 0,
    // border: '1px solid purple',
}

const innerFormItemStyles = {
    marginBottom: 0,
}

const descriptionStyles = {
    fontSize: '16px',
    lineHeight: '22px',
    color: '#5B6E84',
}

const GenerateQuestionFields = ({ questionData }) => {
    const { id, question, type } = questionData

    console.log(question,type,'question data')

    const [listFields, setListFields] = useState([{ id: 0, showDltBtn: false }])
    const [currentId, setCurrentId] = useState(0)

    useEffect(() => {
        if(type === 'list' && questionData.answer) {
            const arr = []
            questionData.answer.split('$').forEach((item, index) => {
                arr.push({id: index, showDltBtn: false, value: item})
                setCurrentId(index)
            })
            setListFields(arr)
        }
    }, [])

    const handleAddListField = () => {
        setListFields([...listFields, {id: currentId+1, showDltBtn: true}])
        setCurrentId(currentId+1)
    }

    const handleDeleteListField = (id) => {
        const filtered = listFields.filter(item => item.id !== id)
        setListFields(filtered)
    }

    switch (type) {
        case 'binary':
            return (
                <Form.Item style={formItemStyles}>
                    <Flex vertical={true} gap={20} style={{  }}>
                        <Flex vertical={true} gap={6}>
                            <Typography.Text style={questionStyles}>{question}</Typography.Text>
                            {questionData.description && <Typography.Text style={descriptionStyles}>{questionData.description}</Typography.Text>}
                        </Flex>
                        <Form.Item name={id}
                            rules={[{ required: true, message: 'Please answer' }]}
                            style={innerFormItemStyles}
                        >
                            <Radio.Group>
                                <Radio value={true}>Yes</Radio>
                                <Radio value={false}>No</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Flex>
                </Form.Item>
            )
        
        case 'checkbox':
            return (
                <Form.Item style={formItemStyles}>
                    <Flex vertical={true} gap={20} style={{}}>
                        <Flex vertical={true} gap={6}>
                            <Typography.Text style={questionStyles}>{question}</Typography.Text>
                            {questionData.description && <Typography.Text style={descriptionStyles}>{questionData.description}</Typography.Text>}
                        </Flex>
                        <Form.Item name={id}
                            // rules={[{ required: true, message: 'Please answer' }]}
                            style={innerFormItemStyles}
                        >
                            <Select
                                mode={"single"}
                                allowClear
                                style={{
                                    maxWidth: '832px',
                                }}
                                placeholder="Please select"
                                options={questionData.checkboxes ? questionData.checkboxes.map(({ option,marks }) => {
                                    return { label: option, value: option }
                                })
                                : questionData.answer.split('$').map(option => ({ label: option, value: option }))}
                            />
                        </Form.Item>
                    </Flex>
                </Form.Item>
            )

        case 'text':
            return (
                <Form.Item style={formItemStyles}>
                    <Flex vertical={true} gap={20} style={{  }}>
                        <Flex vertical={true} gap={6}>
                            <Typography.Text style={questionStyles}>{question}</Typography.Text>
                            {questionData.description && <Typography.Text style={descriptionStyles}>{questionData.description}</Typography.Text>}
                        </Flex>
                        <Form.Item name={id}
                            // rules={[{ required: true, message: 'Please answer' }]}
                            style={innerFormItemStyles}
                        >
                            <TextArea
                                style={{width: '90%'}}
                                placeholder="Answer"
                                autoSize={{
                                    minRows: 4,
                                    maxRows: 8,
                                }}
                            />
                        </Form.Item>
                    </Flex>
                </Form.Item>
            )

        case 'list':
            return (
                <Form.Item style={formItemStyles}>
                    <Flex vertical={true} gap={20} style={{  }}>
                        <Flex vertical={true} gap={6}>
                            <Typography.Text style={questionStyles}>{question}</Typography.Text>
                            {questionData.description && <Typography.Text style={descriptionStyles}>{questionData.description}</Typography.Text>}
                        </Flex>
                        {listFields.map(item => <Form.Item key={'list-'+id+'-'+item.id} name={'list-'+id+'-'+item.id}
                            // rules={item.required ? [{ required: true, message: 'Please answer' }] : []}
                            // style={{marginBottom: '4px'}}
                            style={innerFormItemStyles}
                        >
                            <Flex>
                                <TextArea
                                    style={{width: '90%', marginRight: '8px'}}
                                    placeholder="Answer"
                                    autoSize={{
                                        minRows: 4,
                                        maxRows: 8,
                                    }}
                                    value={item.value}
                                />
                                {item.showDltBtn && <Button size='small' icon={<DeleteOutlined />} onClick={() => handleDeleteListField(item.id)} />}
                            </Flex>
                        </Form.Item>)}
                        <Space>
                            <Button type='default' onClick={handleAddListField}>Add field</Button>
                            <Typography.Text>(You can add multiple answers)</Typography.Text>
                        </Space>
                    </Flex>
                </Form.Item>
            )
    }

}

export default GenerateQuestionFields
